import React from 'react';

export function createMandatoryContext<T>(_defaultValue?: T) {
    const context = React.createContext<T>(undefined as any as T);
    const consumer: React.Consumer<T> = ((props: any) => (
        <context.Consumer>{(state) => (state ? props.children(state) : <span style={{ color: 'red' }}>Missing Context</span>)}</context.Consumer>
    )) as any;
    return {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Provider: context.Provider,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Consumer: consumer,
        context,
    };
}
